import { inject, observer } from 'mobx-react';
import * as React from 'react';

import Spinner from '../../common/spinner';

import { StepsCommonProps } from '../../types';

@inject('userInfoStore')
@observer
class StepFinish extends React.Component<StepsCommonProps> {
constructor(props: StepsCommonProps) {
    super(props);
  }

  public async componentWillMount() {
    const store = this.props.userInfoStore!;
    try {
      await store.submitUserInfo();
    } catch (error) {
      console.error(error);
    }
  }

  public render() {
    if (this.props.userInfoStore!.awaitServer) {
      return  (
        <div className="container step-finish">
          <div className="columns is-centered">
            <Spinner />
          </div>
          <div className="columns is-centered">
            <div className="column is-12 has-text-centered">
              <p className="title is-4">Thanks for your patience!</p>
              <p className="subtitle is-6">Please wait while we collect the data ☕</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        {/** Prompt user */}
        <div className="column is-12 has-text-centered has-text-black-ter">
          <p className="is-size-5 has-text-weight-bold">You are all set!</p>
          <p className="is-size-6">Thanks for taking time to complete your profile 🎉</p>
          <div className="empty-block-prompt-icon has-text-grey"><i className="fas fa-tasks" /></div>
        </div>
      </>
    );
  }
}

export default StepFinish;



// WEBPACK FOOTER //
// ./src/pages/user-info/StepFinish.tsx